import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGalleryView = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.75 7.75a2 2 0 0 1 2-2h4.5a2 2 0 0 1 2 2v8.5a2 2 0 0 1-2 2h-4.5a2 2 0 0 1-2-2z"
    />
    <path
      fill="currentColor"
      d="M10.25 8.5a.75.75 0 0 0 0-1.5zm0 9.5a.75.75 0 0 0 0-1.5zm-.5-9.5h.5V7h-.5zm.5 8h-.5V18h.5zM8.5 15.25v-5.5H7v5.5zm1.25 1.25c-.69 0-1.25-.56-1.25-1.25H7A2.75 2.75 0 0 0 9.75 18zm0-9.5A2.75 2.75 0 0 0 7 9.75h1.5c0-.69.56-1.25 1.25-1.25z"
    />
    <path
      fill="currentColor"
      d="M7.25 9.5a.75.75 0 0 0 0-1.5zm0 7.5a.75.75 0 0 0 0-1.5zm-.5-7.5h.5V8h-.5zm.5 6h-.5V17h.5zM5.5 14.25v-3.5H4v3.5zm1.25 1.25c-.69 0-1.25-.56-1.25-1.25H4A2.75 2.75 0 0 0 6.75 17zm0-7.5A2.75 2.75 0 0 0 4 10.75h1.5c0-.69.56-1.25 1.25-1.25z"
    />
  </svg>
);
export default SvgGalleryView;
